(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flora-free-month"]) return;
  try {
    
                                      document.addEventListener('submit',async event=>{const form=event.target.closest('[data-fm-form]');if(!form)return;event.preventDefault();const button=form.querySelector('button[type=submit]'),error=form.querySelector('[data-error]');button.disabled=true;error.hidden=true;try{const response=await fetch(form.dataset.add,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this offer. Please try again.');window.location.assign('/discount/'+encodeURIComponent(form.dataset.discount)+'?redirect=/checkout')}catch(e){error.textContent=e.message;error.hidden=false;button.disabled=false}});
                                      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flora-ingredients-library"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('flora-ingredient-library')){customElements.define('flora-ingredient-library',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener('click',event=>{const filter=event.target.closest('[data-filter]');if(filter){this.filter(filter.dataset.filter);return}const letter=event.target.closest('[data-letter]');if(letter){this.filter('all');return}const opener=event.target.closest('[data-open]');if(opener){this.opener=opener;const dialog=document.getElementById(opener.dataset.open);if(dialog)dialog.showModal();return}if(event.target.closest('[data-close]'))event.target.closest('dialog').close();if(event.target.tagName==='DIALOG'){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close()}});this.querySelectorAll('dialog').forEach(d=>d.addEventListener('close',()=>this.opener?.focus()))}filter(id){this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===id)));this.querySelectorAll('[data-card]').forEach(c=>c.hidden=id!=='all'&&c.dataset.card!==id)}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magenelle-product"]) return;
  try {
    
if (!customElements.get('mg-reason-carousel')) {
  customElements.define('mg-reason-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mg-reason-track');
      this.cards = [...this.querySelectorAll('.mg-reason-card')];
      this.dots = [...this.querySelectorAll('[data-reason-dot]')];
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-reason-dot]');
        const arrow = event.target.closest('[data-reason-step]');
        if (dot) this.go(Number(dot.dataset.reasonDot));
        if (arrow) this.go((this.index + Number(arrow.dataset.reasonStep) + this.pages) % this.pages);
      }, options);
      this.track.addEventListener('scroll', () => this.sync(), { ...options, passive:true });
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(Math.max(0, Math.min(this.pages - 1, this.index + (event.key === 'ArrowRight' ? 1 : -1))));
        }
      }, options);
      this.observer = new ResizeObserver(() => this.sync());
      this.observer.observe(this.track);
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    sync() {
      this.step = this.cards[1].offsetLeft - this.cards[0].offsetLeft;
      this.pages = Math.max(1, Math.round((this.track.scrollWidth - this.track.clientWidth) / this.step) + 1);
      this.index = Math.min(this.pages - 1, Math.max(0, Math.round(this.track.scrollLeft / this.step)));
      this.dots.forEach((dot, index) => { dot.hidden = index >= this.pages; dot.setAttribute('aria-pressed', String(index === this.index)); });
    }
    go(index) { this.track.scrollTo({ left:index * this.step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
